import { assertNotNullish } from '../utils/types';
const protocolPart = 'tf://';
export const splitObjectId = (objectId) => {
    if (!objectId.startsWith(protocolPart)) {
        throw new Error(`Unexpected object ID format: no ${protocolPart} protocol prefix`);
    }
    const [tenantPart, rest] = objectId.split('@');
    const tenantId = tenantPart.replace(protocolPart, '');
    assertNotNullish(rest, 'Unexpected object ID format: only tenant ID is provided');
    const restParts = rest.split('/');
    if (restParts.length < 3) {
        throw new Error(`Unexpected object ID format: it must consist of cluster ID, schema tag and object name`);
    }
    const clusterId = restParts[0];
    const schemaTag = restParts.slice(1, restParts.length - 1).join('/');
    const [objectName, version] = restParts[restParts.length - 1].split('?');
    return {
        tenantId,
        clusterId,
        schemaTag,
        objectName,
        version,
    };
};
export const extractObjectUuid = (objectId) => {
    const { objectName } = splitObjectId(objectId);
    return objectName;
};
export const createObjectId = (parts) => {
    const objectId = `${protocolPart}${parts.tenantId}@${parts.clusterId}/${parts.schemaTag}/${parts.objectName}`;
    return parts.version ? `${objectId}?${parts.version}` : objectId;
};
export const createObjectAliasId = (parts) => {
    return `${protocolPart}${parts.tenantId}@${parts.clusterId}/${parts.alias}`;
};
// `@aliases.maxProperties` in the object schemas: the cap spans every tag, not one tag
export const MAX_OBJECT_ALIASES = 10;
// `@aliases` maps alias key -> tag, and nothing holds a tag to one key.
export const getObjectAliases = (objectAliases, tag) => {
    if (!objectAliases)
        return [];
    return Object.entries(objectAliases)
        .filter(([, aliasTag]) => aliasTag === tag)
        .map(([alias]) => alias);
};
// @displayName is a special alias for user-friendly identifier
export const getObjectDisplayName = (objectAliases) => {
    // only one displayName alias
    const [displayName] = getObjectAliases(objectAliases, '@displayName');
    return displayName;
};
export const getProfileExternalIds = (objectAliases) => {
    return getObjectAliases(objectAliases, '@externalId');
};
// Kept for the legacy `trustform` app, which still assumes a single profile ID
export const getProfileExternalId = (objectAliases) => {
    const [externalId] = getProfileExternalIds(objectAliases);
    return externalId;
};
//# sourceMappingURL=objectId.js.map